export default __webpack_public_path__ + "static/devices-839a3a0abe1c4cf6ac6ebab67778b8cc.png";